// error?.response?.data?.message

type ErrorResponse = {
  stack?: string
  response?: { data: { message: string } }
}

export const createErrorResponse = (errorMessage: string): ErrorResponse => {
  const error: ErrorResponse = new Error(errorMessage)

  error.response = {
    data: { message: errorMessage }
  }

  return error
}
